import {post} from '../utils/http'
import Config from "../utils/IPconfig";
const config = new Config();
import AppConstants from "../utils/appConstants"
import store from "../store";
function autoLogin(platformId, merchantOppId, childAccountId) {
  let validationKey = hex_md5(merchantOppId + platformId + "yunCang");
  return new Promise((resolve, reject) => {
    post(config.api.user + "/merchant/login", {
      merchantOppId: merchantOppId,
      platformId: platformId,
      validationKey: validationKey,
      childAccountId: childAccountId
    }).then(data => {
      console.log(data);
      // data.childAccountId = childAccountId;
      localStorage.setItem("cloudUser", JSON.stringify(data));
      resolve(data);
    }).catch(err => {
      console.error(err);
      reject(err)
    });
  })
}
function getMerchantNewField() {
  return new Promise((resolve, reject) => {
    post(config.api.user + "/merchant/getMerchantNewField").then(res => {
      let result = {
        merchantType:res.merchantType,
        productCatalogList:res.productCatalogList,
        proCatalogList:[]
      }
      if (res.productCatalogList && res.productCatalogList.length) {
        let allProCategoryList = AppConstants.getAllProductTypeList();
        res.productCatalogList.forEach(item => {
          allProCategoryList.forEach(v => {
            if (item === v.code) result.proCatalogList.push(v)
          })
        })
      }
      store.commit("setMerchantNewField", result)
      resolve(res);
    }).catch(err => {
      console.error(err);
      reject(err)
    });
  })
}

export default function handleRouter(router) {
  router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    const whiteList = ["loginError"];//登陆检测白名单
    if (whiteList.includes(to.name)) {
      next();
    } else {
      const userInfo = JSON.parse(localStorage.getItem("cloudUser"));

      //地址上携带有参数
      if (to.query.platformId && to.query.merchantOppId && to.query.childAccountId >= 0) {
        if (!userInfo || userInfo.merchantOppId != to.query.merchantOppId || userInfo.childAccountId!=to.query.childAccountId) {
          //用户信息为空（没登陆） 店铺id不同或者子账号不同时都要重新登录
          localStorage.removeItem("cloudUser")
          //需要静默登陆
          autoLogin(to.query.platformId,to.query.merchantOppId,to.query.childAccountId).then(res => {
            getMerchantNewField().then(res => {
              next();//登陆成功，跳转真实页面
            }).catch(reason => {
              next({name: "loginError"});//登录失败，跳转失败页面
            })
          }).catch(reason => {
            next({name: "loginError"});//登录失败，跳转失败页面
          })
        }else{
          getMerchantNewField().then(res => {
            next();//登陆成功，跳转真实页面
          }).catch(reason => {
            next({name: "loginError"});//登录失败，跳转失败页面
          })
        }
      } else if (userInfo && userInfo.merchantOppId) {
        getMerchantNewField().then(res => {
          next();//登陆成功，跳转真实页面
        }).catch(reason => {
          next({name: "loginError"});//登录失败，跳转失败页面
        })
      } else {
        next({name: "loginError"})
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/routerHandler.js